<script setup lang="ts">
const store = useBigHeroBannerStore();

defineProps<{
  data: any;
  index: number;
}>();

const loaded = ref(false);

async function onLoad() {
  emitter.emit("LCPEvent");
  loaded.value = true;
  await waitUntilTrue(() => store.status === LoadStatus.Ready);
  store.triggerNextAutoPlay();
}
</script>

<template>
  <BigHeroBannerSlideIntro
    v-if="data?.type === 'INTRO'"
    :key="`slide-intro-${index}`"
    :index="index"
    class="current-slide"
    :class="{ show: loaded }"
    @load="onLoad"
  />

  <BigHeroBannerSlideCallout
    v-else-if="data?.type === 'CALLOUT'"
    :key="`slide-callout-${index}`"
    :index="index"
    class="current-slide"
    :class="{ show: loaded }"
    @load="onLoad"
  />

  <BigHeroBannerSlideArtwork
    v-else-if="data && ['ARTWORK', 'ARTWORK-FIXED'].includes(data.type)"
    :key="`slide-artwork-${index}`"
    :index="index"
    class="current-slide"
    :class="{ show: loaded }"
    @load="onLoad"
  />
</template>

<style scoped lang="postcss">
.current-slide {
  @apply z-10 opacity-0 transition-all;
}
.show {
  @apply opacity-100;
}
</style>
